const features = {
    auth: true,
    channels: true,
    versionCheck: true,
    premium: true,
    settings: true,
    favouritesOnboarding: true,
    premiumOnboarding: true,
}

const paymentServices = [
    {
        alias: 'stripe',
        title: 'Credit Card',
        description: 'Visa, Mastercard & AmEx',
        icon: 'credit-card',
    },
    {
        alias: 'paypal',
        title: 'PayPal',
        description: '',
        icon: 'paypal',
    },
]

const donationProducts = [
    {
        amount: 20,
        stripe: {
            url: 'https://donate.stripe.com/14k8xpcEMgvpgYocMP',
        },
        paypal: {
            url: 'https://www.paypal.com/donate/?hosted_button_id=VVB3YVZVKUKQ4',
        }
    },
    {
        amount: 50,
        stripe: {
            url: 'https://donate.stripe.com/9AQbJBcEMenh7nO3ce',
        },
        paypal: {
            url: 'https://www.paypal.com/donate/?hosted_button_id=KT8ZDDM33Q43Y',
        }
    },
    {
        amount: 100,
        stripe: {
            url: 'https://donate.stripe.com/cN26phcEM2Ez5fG5kl',
        },
        paypal: {
            url: 'https://www.paypal.com/donate/?hosted_button_id=EQRPKHZESLUNN',
        }
    },
]

const onDemandQualityOptions = {
    low: {
        title: 'Normal',
        subtitle: '',
        value: '96',
        needsSub: false
    },
    high: {
        title: 'High - FRISKY Premium only',
        subtitle: 'Great sound quality',
        value: '128',
        needsSub: true
    },
    best: {
        title: 'Best - FRISKY Premium only',
        subtitle: 'High-Resolution audio quality',
        value: '320',
        needsSub: true
    },
}

const trialDays = 7 // Number of days to allow for a trial period

const feedbackMessageMemberId = 5

const supportEmail = "support@friskyradio.com"

const nativeApps = {
    iosAppId: `id${process.env.VUE_APP_APPLE_APP_ID}`
}

export {
    features,
    paymentServices,
    donationProducts,
    trialDays,
    onDemandQualityOptions,
    feedbackMessageMemberId,
    supportEmail,
    nativeApps
}
